import React from "react";
import PropTypes from "prop-types";
import HorizontalSlider from "../../../common/HorizontalSlider";
import classNames from "classnames";

import styles from "./departments.module.scss";

function Departments({items, active, onClick}) {
  return (
    <div className={styles.root}>
      <HorizontalSlider
        dots={false}
        arrows={false}
        swipeToSlide={true}
        slidesToShow={items.length}
        variableWidth
        infinite={false}
        className={styles.slider}
        responsive={[
          {
            breakpoint: 2000,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1
            }
          }
        ]}
      >
        {items.map(({title}) => (
          <div key={title} className={styles.item}>
            <button
              onClick={() => onClick(title)}
              className={classNames(
                styles.link,
                active === title && styles.linkActive
              )}
            >
              {title}
            </button>
          </div>
        ))}
      </HorizontalSlider>
    </div>
  );
}

Departments.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      title: PropTypes.string
    })
  ),
  active: PropTypes.string,
  onClick: PropTypes.func
};

export default Departments;
